/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CREATE_METRO2_USER_COMMENT = gql`
mutation createMetro2UserComment($input: CreateMetro2UserCommentInput) {
	createMetro2UserComment(input: $input)
}`;

export const UPDATE_METRO2_USER_COMMENT = gql`
mutation updateMetro2UserComment($input: UpdateMetro2UserCommentInput) {
	updateMetro2UserComment(input: $input)
}`;

export const DELETE_METRO2_USER_COMMENT = gql`
mutation deleteMetro2UserComment($input: DeleteMetro2UserCommentInput) {
	deleteMetro2UserComment(input: $input)
}`;

export const CREATE_CLASSIFY_AUDIT_LOG_FOR_METRO2 = gql`
mutation createClassifyAuditLogForMetro2($input: ClassifyMetro2Input) {
	createClassifyAuditLogForMetro2(input: $input)
}`;
